import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, watch} from 'vue';
import appStoreModule from '@/store/modules/app';
import {getWantToBuyHotList, searchCategories, getSupplyHotList} from '@/api/miscellaneous';
import {onBeforeRouteLeave} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchCategorie',
  props: {
    modelValue: {
        type: Boolean,
        default: false,
    },
    keyword: {
        type: String,
        default: '',
    },
    hotType: {
        type: String,
        default: 'wantToBuy',
    },
},
  emits: ['update:modelValue', 'selected', 'update:keyword', 'cancel'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props




const isShowSearch = ref(false);
const categories = ref<any[]>([]);
const getListData = ref({
    name: ref(props.keyword).value,
    pageNum: 1,
    pageSize: 10,
});
const loading = ref(false);
const finished = ref(false);

const history = ref<any[]>([]);
const hotList = ref<any[]>([]);

onMounted(() => {
    appStoreModule.init();
    history.value = appStoreModule.history;
    getHotList();
});

const getHotList = () => {
    switch (props.hotType) {
        case 'wantToBuy':
            getWantToBuyHotList().then((res: any) => {
                hotList.value = res.map((el: {categoryName: any}) => ({...el, ...{name: el.categoryName}}));
            });
            break;
        case 'supply':
            getSupplyHotList().then((res: any) => {
                hotList.value = res.map((el: {categoryName: any}) => ({...el, ...{name: el.categoryName}}));
            });
            break;
    }
};

let timer: any = null;
const searchVariety = (): void => {
    if (timer) clearTimeout(timer);
    loading.value = true;
    timer = setTimeout(() => {
        getListData.value.pageNum = 1;
        if (getListData.value.name) {
            searchCategories(getListData.value).then((res: any) => {
                loading.value = false;
                categories.value = res.items;
            });
        }
    }, 500);
};

const page = () => {
    if (loading.value) return;
    loading.value = true;
    getListData.value.pageNum += 1;
    searchCategories(getListData.value).then((res: any) => {
        categories.value = [...categories.value, ...res.items];
        loading.value = false;
        finished.value = res.count == 0 ? true : getListData.value.pageNum * getListData.value.pageSize > res.totalCount;
    });
};
const selected = (item: any) => {
    appStoreModule.setVariety({data: item, type: 'history'});
    history.value = appStoreModule.history;
    getListData.value.name = item.name;
    emit('update:keyword', item.name);
    emit('selected', item);
};

watch(
    () => getListData.value.name,
    val => {
        emit('update:keyword', val);
        searchVariety();
    },
);
watch(
    () => props.modelValue,
    val => {
        if (val) {
            searchVariety();
        }
    },
);

watch(
    () => props.keyword,
    val => {
        getListData.value.name = val;
    },
);

onBeforeRouteLeave((to, from, next) => {
    emit('update:modelValue', false);
    next();
});

const __returned__ = { emit, props, isShowSearch, categories, getListData, loading, finished, history, hotList, getHotList, timer, searchVariety, page, selected, ref, onMounted, watch, appStoreModule, getWantToBuyHotList, searchCategories, getSupplyHotList, onBeforeRouteLeave }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})